// AUTO-GENERATED by vite-plugin-tool-discovery — do not edit
import type { ComponentType } from 'react';

export const componentRegistry: Record<string, () => Promise<{ default: ComponentType<any> }>> = {
  CashCountCategoryMaintenance: () => import('@/tools/cash-count-category-maintenance'),
  CashCountManagement: () => import('@/tools/CashCountManagement'),
  CashierManagement: () => import('@/tools/CashierManagement'),
  ComboBoxMaintenance: () => import('@/tools/ComboBoxMaintenance'),
  CurrencyBagManagement: () => import('@/tools/CurrencyBagManagement'),
  DepartmentMaintenance: () => import('@/tools/DepartmentMaintenance'),
  DepositCategoryMaintenance: () => import('@/tools/DepositCategoryMaintenance'),
  DepositCategoryTypeMaintenance: () => import('@/tools/DepositCategoryTypeMaintenance'),
  DocumentDesigner: () => import('@/tools/DocumentDesigner'),
  DocumentTypes: () => import('@/tools/DocumentTypes'),
  DropAndIssue: () => import('@/tools/DropAndIssue'),
  EmployeeMaintenance: () => import('@/tools/EmployeeMaintenance'),
  GameDays: () => import('@/tools/GameDays'),
  GLAccountCodeMaintenance: () => import('@/tools/GLAccountCodeMaintenance'),
  GLMapping: () => import('@/tools/GLMapping'),
  Home: () => import('@/tools/Home'),
  MachineCountManagement: () => import('@/tools/MachineCountManagement'),
  MachineTool: () => import('@/tools/machine-settings'),
  MyCashierManagement: () => import('@/tools/MyCashierManagement'),
  RevenueCenterMaintenance: () => import('@/tools/RevenueCenterMaintenance'),
  RoleMaintenanceTool: () => import('@/tools/RoleMaintenanceTool'),
  SecurityControls: () => import('@/tools/SecurityControls'),
  SystemOptions: () => import('@/tools/SystemOptions'),
  TableCountManagement: () => import('@/tools/TableCountManagement'),
  TaskStatusMaintenance: () => import('@/tools/TaskStatusMaintenance'),
  TaskTypeMaintenance: () => import('@/tools/TaskTypeMaintenance'),
  TicketTypeMaintenance: () => import('@/tools/TicketTypeMaintenance'),
  TipEmployeeManagement: () => import('@/tools/TipEmployeeManagement'),
  TipPoolMaintenance: () => import('@/tools/TipPoolMaintenance'),
  TransactionTypeMaintenance: () => import('@/tools/TransactionTypeMaintenance'),
  VaultLocationMaintenance: () => import('@/tools/VaultLocationMaintenance'),
  VaultManagement: () => import('@/tools/VaultManagement'),
};
